const foodData = [
  {
    food: "M&M's Plain",
    type: "Snacks",
    serving: "bag",
    size: 1,
    weight: 48,
    protein: 3.02,
    fat: 10.66,
    carbohydrates: 32.74,
    calories: 228.48,
    sugar: null,
  },
  {
    food: "Rice (cooked)",
    type: "Bread & Grains",
    serving: "cup",
    size: 1,
    weight: 158,
    protein: 4.25,
    fat: 0.44,
    carbohydrates: 44.51,
    calories: 205.4,
    sugar: null,
  },
  {
    food: "Avocado",
    type: "Fruits",
    serving: "cup",
    size: 1,
    weight: 146,
    protein: 2.9,
    fat: 21.4,
    carbohydrates: 12.5,
    calories: 233.6,
    sugar: 1,
  },
  {
    food: "Ilba (Traditional)",
    type: "Traditional Dishes",
    serving: "1/2 cup",
    size: 0.5,
    weight: 100,
    protein: 4.3,
    fat: 3.3,
    carbohydrates: 17.8,
    calories: 118,
    sugar: null,
  },
  {
    food: "Aloo (Traditional)",
    type: "Traditional Dishes",
    serving: "3 pieces",
    size: 3,
    weight: 100,
    protein: 2.63,
    fat: 4.86,
    carbohydrates: 20.6,
    calories: 136,
    sugar: null,
  },
  {
    food: "Pineapple",
    type: "Fruits",
    serving: "cup",
    size: 1,
    weight: 155,
    protein: 0.8,
    fat: 0.2,
    carbohydrates: 20.3,
    calories: 77.5,
    sugar: 14.4,
  },
  {
    food: "Canned Pineapple",
    type: "Beverages",
    serving: "cup",
    size: 1,
    weight: 255,
    protein: 0.89,
    fat: 0.28,
    carbohydrates: 51.51,
    calories: 198.9,
    sugar: null,
  },
  {
    food: "Omelette",
    type: "Eggs",
    serving: "egg",
    size: 1,
    weight: 61,
    protein: 6.5,
    fat: 7.3,
    carbohydrates: 0.4,
    calories: 95.8,
    sugar: 0.4,
  },
  {
    food: "Vanilla Ice Cream",
    type: "Snacks",
    serving: "1/2 cup",
    size: 0.5,
    weight: 90,
    protein: 4.62,
    fat: 14.52,
    carbohydrates: 31.15,
    calories: 265.32,
    sugar: null,
  },
  {
    food: "Strawberry Ice Cream",
    type: "Snacks",
    serving: "1/2 cup",
    size: 0.5,
    weight: 90,
    protein: 4.22,
    fat: 11.09,
    carbohydrates: 36.43,
    calories: 253.44,
    sugar: null,
  },
  {
    food: "Chocolate Ice Cream",
    type: "Snacks",
    serving: "1/2 cup",
    size: 0.5,
    weight: 91,
    protein: 4.2,
    fat: 14.9,
    carbohydrates: 20.2,
    calories: 232,
    sugar: null,
  },
  {
    food: "Ice Cream Sandwich",
    type: "Snacks",
    serving: "piece",
    size: 1,
    weight: 63,
    protein: 3,
    fat: 6,
    carbohydrates: 27,
    calories: 170,
    sugar: null,
  },
  {
    food: "Green Peas",
    type: "Vegetables",
    serving: "cup",
    size: 1,
    weight: 160,
    protein: 8.6,
    fat: 0.4,
    carbohydrates: 25,
    calories: 134.4,
    sugar: 9.5,
  },
  {
    food: "Orange",
    type: "Fruits",
    serving: "1 medium",
    size: 1,
    weight: 131,
    protein: 1.2,
    fat: 0.2,
    carbohydrates: 15.4,
    calories: 61.6,
    sugar: 12.2,
  },
  {
    food: "Sweet Potato",
    type: "Vegetables",
    serving: "1 medium",
    size: 1,
    weight: 130,
    protein: 2,
    fat: 0.1,
    carbohydrates: 26.2,
    calories: 111.8,
    sugar: 5.4,
  },
  {
    food: "Parsley",
    type: "Vegetables",
    serving: "10 sprigs",
    size: 10,
    weight: 10,
    protein: 0.3,
    fat: 0.1,
    carbohydrates: 0.6,
    calories: 3.6,
    sugar: 0.1,
  },
  {
    food: "Lupin Beans",
    type: "Vegetables",
    serving: "cup",
    size: 1,
    weight: 166,
    protein: 25.8,
    fat: 4.8,
    carbohydrates: 16.4,
    calories: 197.5,
    sugar: null,
  },
  {
    food: "Dates",
    type: "Fruits",
    serving: "4 pieces",
    size: 4,
    weight: 32,
    protein: 0.8,
    fat: 0.1,
    carbohydrates: 24,
    calories: 90.2,
    sugar: 20.3,
  },
  {
    food: "Blueberries",
    type: "Fruits",
    serving: "cup",
    size: 1,
    weight: 145,
    protein: 1.1,
    fat: 0.5,
    carbohydrates: 21,
    calories: 82.6,
    sugar: 14.4,
  },
  {
    food: "Blackberries",
    type: "Fruits",
    serving: "cup",
    size: 1,
    weight: 144,
    protein: 2,
    fat: 0.7,
    carbohydrates: 13.8,
    calories: 61.9,
    sugar: 7,
  },
  {
    food: "Cranberries",
    type: "Fruits",
    serving: "cup",
    size: 1,
    weight: 95,
    protein: 0.4,
    fat: 0.1,
    carbohydrates: 11.6,
    calories: 43.7,
    sugar: 3.8,
  },
  {
    food: "Fig",
    type: "Fruits",
    serving: "1 medium",
    size: 1,
    weight: 50,
    protein: 0.4,
    fat: 0.2,
    carbohydrates: 9.6,
    calories: 37,
    sugar: 8.1,
  },
  {
    food: "Rocket / Arugula",
    type: "Vegetables",
    serving: "cup",
    size: 1,
    weight: 34,
    protein: 0.8,
    fat: null,
    carbohydrates: 0.4,
    calories: 3.7,
    sugar: 0.1,
  },
  {
    food: "Peach",
    type: "Fruits",
    serving: "1 medium",
    size: 1,
    weight: 150,
    protein: 1.4,
    fat: 0.4,
    carbohydrates: 14.3,
    calories: 58.5,
    sugar: 12.6,
  },
  {
    food: "Dried Prunes",
    type: "Fruits",
    serving: "cup (halves)",
    size: 0.5,
    weight: 160,
    protein: 5.8,
    fat: 1.2,
    carbohydrates: 98.1,
    calories: 382.4,
    sugar: 66.8,
  },
  {
    food: "Purslane",
    type: "Vegetables",
    serving: "cup",
    size: 1,
    weight: 43,
    protein: 0.6,
    fat: null,
    carbohydrates: 1.5,
    calories: 6.9,
    sugar: null,
  },
  {
    food: "Spinach",
    type: "Vegetables",
    serving: "cup",
    size: 1,
    weight: 30,
    protein: 0.9,
    fat: 0.1,
    carbohydrates: 1.1,
    calories: 6.9,
    sugar: 0.1,
  },
  {
    food: "Cantaloupe",
    type: "Fruits",
    serving: "cup (pieces)",
    size: 1,
    weight: 177,
    protein: 1.5,
    fat: 0.3,
    carbohydrates: 14.4,
    calories: 60.2,
    sugar: 13.9,
  },
  {
    food: "Black Beans",
    type: "Vegetables",
    serving: "cup",
    size: 1,
    weight: 164,
    protein: 14.5,
    fat: 4.2,
    carbohydrates: 45,
    calories: 269,
    sugar: 7.9,
  },
  {
    food: "Kidney Beans",
    type: "Vegetables",
    serving: "cup",
    size: 1,
    weight: 177,
    protein: 15.3,
    fat: 0.9,
    carbohydrates: 40.4,
    calories: 224.8,
    sugar: 0.6,
  },
  {
    food: "Green Beans",
    type: "Vegetables",
    serving: "cup",
    size: 1,
    weight: 110,
    protein: 2,
    fat: 0.1,
    carbohydrates: 7.8,
    calories: 34.1,
    sugar: 1.5,
  },
  {
    food: "Radish",
    type: "Vegetables",
    serving: "slices (1/2 cup)",
    size: 0.5,
    weight: 58,
    protein: 0.4,
    fat: 0.1,
    carbohydrates: 2,
    calories: 9.3,
    sugar: 1.2,
  },
  {
    food: "Cauliflower",
    type: "Vegetables",
    serving: "cup",
    size: 1,
    weight: 100,
    protein: 2,
    fat: 0.1,
    carbohydrates: 5.3,
    calories: 25,
    sugar: 2.4,
  },
  {
    food: "Chives",
    type: "Vegetables",
    serving: "4 tsp",
    size: 4,
    weight: 40,
    protein: 1,
    fat: null,
    carbohydrates: 6.7,
    calories: 28.8,
    sugar: null,
  },
  {
    food: "Sour Cherries",
    type: "Fruits",
    serving: "cup",
    size: 1,
    weight: 103,
    protein: 1,
    fat: 0.3,
    carbohydrates: 12.5,
    calories: 51.5,
    sugar: 8.7,
  },
  {
    food: "Sweet Cherries",
    type: "Fruits",
    serving: "cup",
    size: 1,
    weight: 117,
    protein: 1.2,
    fat: 0.2,
    carbohydrates: 18.7,
    calories: 73.7,
    sugar: 15,
  },
  {
    food: "Coriander",
    type: "Vegetables",
    serving: "9 sprigs",
    size: 9,
    weight: 20,
    protein: 0.4,
    fat: 0.1,
    carbohydrates: 0.7,
    calories: 4.6,
    sugar: 0.2,
  },
  {
    food: "Turnip",
    type: "Vegetables",
    serving: "cup sliced",
    size: 1,
    weight: 67,
    protein: 2.2,
    fat: 0.5,
    carbohydrates: 6.7,
    calories: 33.5,
    sugar: null,
  },
  {
    food: "Ammoush (Traditional)",
    type: "Traditional Dishes",
    serving: "1/2 cup",
    size: 0.5,
    weight: 100,
    protein: 6.84,
    fat: 1.7,
    carbohydrates: 26.81,
    calories: 149.9,
    sugar: null,
  },
  {
    food: "Papaya",
    type: "Fruits",
    serving: "1 medium",
    size: 1,
    weight: 304,
    protein: 1.9,
    fat: 0.4,
    carbohydrates: 29.8,
    calories: 118.6,
    sugar: 17.9,
  },
  {
    food: "Bajela (Traditional Beans)",
    type: "Traditional Dishes",
    serving: "1/2 cup",
    size: 0.5,
    weight: 100,
    protein: 6.2,
    fat: 1,
    carbohydrates: 16.3,
    calories: 99,
    sugar: null,
  },
  {
    food: "Eggplant / Aubergine",
    type: "Vegetables",
    serving: "1/2 cup",
    size: 0.5,
    weight: 82,
    protein: 0.84,
    fat: 0.15,
    carbohydrates: 4.98,
    calories: 21.32,
    sugar: null,
  },
  {
    food: "Frozen Peas",
    type: "Vegetables",
    serving: "cup",
    size: 1,
    weight: 63,
    protein: 1.8,
    fat: 0.1,
    carbohydrates: 4.8,
    calories: 26.5,
    sugar: 2.5,
  },
  {
    food: "M&M's Hazelnut",
    type: "Snacks",
    serving: "1 bag",
    size: 1,
    weight: 49,
    protein: 5.24,
    fat: 13.18,
    carbohydrates: 28.91,
    calories: 242.55,
    sugar: null,
  },
  {
    food: "Okra",
    type: "Vegetables",
    serving: "cup",
    size: 1,
    weight: 100,
    protein: 2,
    fat: 0.1,
    carbohydrates: 7,
    calories: 31,
    sugar: 1.2,
  },
  {
    food: "Bathith (Traditional)",
    type: "Traditional Dishes",
    serving: "1/2 cup",
    size: 0.5,
    weight: 100,
    protein: 2.6,
    fat: 6.4,
    carbohydrates: 71,
    calories: 352,
    sugar: null,
  },
  {
    food: "Bukhari Chicken Rice",
    type: "Traditional Dishes",
    serving: "1/2 cup",
    size: 0.5,
    weight: 100,
    protein: 18.6,
    fat: 2.8,
    carbohydrates: 17.4,
    calories: 169,
    sugar: null,
  },
  {
    food: "Bukhari Lamb Rice",
    type: "Traditional Dishes",
    serving: "1/2 cup",
    size: 0.5,
    weight: 100,
    protein: 22.49,
    fat: 1.32,
    carbohydrates: 7.83,
    calories: 133,
    sugar: null,
  },
  {
    food: "Bakhsam (Traditional Bread)",
    type: "Bread & Grains",
    serving: "piece",
    size: 1,
    weight: 10,
    protein: 1.2,
    fat: 0.95,
    carbohydrates: 6.84,
    calories: 41.2,
    sugar: null,
  },
  {
    food: "Chicken Burger",
    type: "Traditional Dishes",
    serving: "1 medium",
    size: 1,
    weight: 100,
    protein: 8.5,
    fat: 2.8,
    carbohydrates: 33.4,
    calories: 193,
    sugar: null,
  },
  {
    food: "Beef Burger",
    type: "Traditional Dishes",
    serving: "1 medium",
    size: 1,
    weight: 100,
    protein: 10,
    fat: 4.3,
    carbohydrates: 33.3,
    calories: 176.2,
    sugar: null,
  },
  {
    food: "Pringles Onion Flavour",
    type: "Snacks",
    serving: "small can",
    size: 1,
    weight: 50,
    protein: 4.05,
    fat: 16.949,
    carbohydrates: 25.75,
    calories: 265.5,
    sugar: null,
  },
  {
    food: "Pringles Cheese Flavour",
    type: "Snacks",
    serving: "small can",
    size: 1,
    weight: 50,
    protein: 3.49,
    fat: 18.5,
    carbohydrates: 25.31,
    calories: 275.5,
    sugar: null,
  },
  {
    food: "Broccoli",
    type: "Vegetables",
    serving: "cup",
    size: 1,
    weight: 91,
    protein: 2.6,
    fat: 0.3,
    carbohydrates: 6,
    calories: 30.9,
    sugar: 1.5,
  },
  {
    food: "Chicken Biryani",
    type: "Traditional Dishes",
    serving: "1/2 cup",
    size: 0.5,
    weight: 100,
    protein: 15.38,
    fat: 2.5,
    carbohydrates: 14,
    calories: 141.2,
    sugar: null,
  },
  {
    food: "Lamb Biryani",
    type: "Traditional Dishes",
    serving: "1/2 cup",
    size: 0.5,
    weight: 100,
    protein: 17.99,
    fat: 2.63,
    carbohydrates: 13.05,
    calories: 142.9,
    sugar: null,
  },
  {
    food: "Cheese Biscuit",
    type: "Bread & Grains",
    serving: "1 piece",
    size: 1,
    weight: 1,
    protein: 0.1,
    fat: 0.25,
    carbohydrates: 0.58,
    calories: 5.03,
    sugar: null,
  },
  {
    food: "Wheat Biscuit",
    type: "Bread & Grains",
    serving: "1 piece",
    size: 1,
    weight: 2,
    protein: 0.17,
    fat: 0.41,
    carbohydrates: 1.3,
    calories: 9.46,
    sugar: null,
  },
  {
    food: "Salted Cracker",
    type: "Bread & Grains",
    serving: "1 piece",
    size: 1,
    weight: 3,
    protein: 0.22,
    fat: 0.76,
    carbohydrates: 1.83,
    calories: 15.06,
    sugar: null,
  },
  {
    food: "Onion",
    type: "Vegetables",
    serving: "cup (chopped)",
    size: 1,
    weight: 160,
    protein: 1.8,
    fat: 0.2,
    carbohydrates: 14.9,
    calories: 64,
    sugar: 6.8,
  },
  {
    food: "Roast Duck (skinless)",
    type: "Meats",
    serving: "palm-sized",
    size: 1,
    weight: 85,
    protein: 20,
    fat: 9.5,
    carbohydrates: 0,
    calories: 170.8,
    sugar: 0,
  },
  {
    food: "Roast Duck (with skin)",
    type: "Meats",
    serving: "palm-sized",
    size: 1,
    weight: 85,
    protein: 16.1,
    fat: 24.1,
    carbohydrates: 0,
    calories: 286.4,
    sugar: 0,
  },
  {
    food: "Potato",
    type: "Vegetables",
    serving: "1 medium",
    size: 1,
    weight: 213,
    protein: 4.3,
    fat: 0.2,
    carbohydrates: 37.2,
    calories: 164,
    sugar: 1.7,
  },
  {
    food: "French Fries",
    type: "Traditional Dishes",
    serving: "50 pieces",
    size: 50,
    weight: 100,
    protein: 2.8,
    fat: 5.6,
    carbohydrates: 31.4,
    calories: 187,
    sugar: null,
  },
  {
    food: "Baqsamat (Toasted Bread)",
    type: "Bread & Grains",
    serving: "cup",
    size: 1,
    weight: 108,
    protein: 14.4,
    fat: 5.7,
    carbohydrates: 77.7,
    calories: 426.6,
    sugar: null,
  },
  {
    food: "Balaleet (Traditional)",
    type: "Traditional Dishes",
    serving: "1/2 cup",
    size: 0.5,
    weight: 100,
    protein: 5.5,
    fat: 6.1,
    carbohydrates: 30.4,
    calories: 199,
    sugar: null,
  },
  {
    food: "Borage",
    type: "Vegetables",
    serving: "cup",
    size: 1,
    weight: 33,
    protein: 0.3,
    fat: null,
    carbohydrates: 1.1,
    calories: 5,
    sugar: null,
  },
  {
    food: "Egg White",
    type: "Eggs",
    serving: "egg white",
    size: 1,
    weight: 33,
    protein: 3.6,
    fat: 0.1,
    carbohydrates: 0.2,
    calories: 15.8,
    sugar: 0.2,
  },
  {
    food: "Goose Egg",
    type: "Eggs",
    serving: "egg",
    size: 1,
    weight: 144,
    protein: 20,
    fat: 19.1,
    carbohydrates: 1.9,
    calories: 266.4,
    sugar: 1.4,
  },
  {
    food: "Turkey Egg",
    type: "Eggs",
    serving: "egg",
    size: 1,
    weight: 79,
    protein: 10.8,
    fat: 9.4,
    carbohydrates: 0.9,
    calories: 135.1,
    sugar: null,
  },
  {
    food: "Quail Egg",
    type: "Eggs",
    serving: "egg",
    size: 1,
    weight: 9,
    protein: 1.2,
    fat: 1,
    carbohydrates: null,
    calories: 14.2,
    sugar: null,
  },
  {
    food: "Duck Egg",
    type: "Eggs",
    serving: "egg",
    size: 1,
    weight: 70,
    protein: 9,
    fat: 9.6,
    carbohydrates: 1,
    calories: 129.5,
    sugar: 0.7,
  },
  {
    food: "Chicken Egg",
    type: "Eggs",
    serving: "egg",
    size: 1,
    weight: 50,
    protein: 6.3,
    fat: 5,
    carbohydrates: 0.4,
    calories: 71.5,
    sugar: 0.4,
  },
  {
    food: "Dried Egg",
    type: "Eggs",
    serving: "tsp",
    size: 1,
    weight: 5,
    protein: 2.4,
    fat: 2.2,
    carbohydrates: 0.1,
    calories: 30.8,
    sugar: null,
  },
  {
    food: "Scrambled Egg with Milk",
    type: "Eggs",
    serving: "egg",
    size: 1,
    weight: 61,
    protein: 6.8,
    fat: 7.4,
    carbohydrates: 1.3,
    calories: 101.9,
    sugar: 1.1,
  },
  {
    food: "Boiled Egg",
    type: "Eggs",
    serving: "egg",
    size: 1,
    weight: 50,
    protein: 6.3,
    fat: 5.3,
    carbohydrates: 0.6,
    calories: 77.5,
    sugar: 0.6,
  },
  {
    food: "Fried Egg",
    type: "Eggs",
    serving: "egg",
    size: 1,
    weight: 46,
    protein: 6.3,
    fat: 7,
    carbohydrates: 0.4,
    calories: 90.2,
    sugar: 0.4,
  },
  {
    food: "Tabbouleh",
    type: "Vegetables",
    serving: "2 tbsp",
    size: 2,
    weight: 28.35,
    protein: 1,
    fat: 2,
    carbohydrates: 2,
    calories: 30,
    sugar: null,
  },
  {
    food: "Apple",
    type: "Fruits",
    serving: "1 medium",
    size: 1,
    weight: 138,
    protein: 0.4,
    fat: 0.2,
    carbohydrates: 19.1,
    calories: 71.8,
    sugar: 14.3,
  },
  {
    food: "Dried Apple",
    type: "Fruits",
    serving: "slice",
    size: 1,
    weight: 98,
    protein: 0.9,
    fat: 0.3,
    carbohydrates: 64.6,
    calories: 238.1,
    sugar: 56,
  },
  {
    food: "Tikka Lamb",
    type: "Traditional Dishes",
    serving: "palm-sized",
    size: 1,
    weight: 100,
    protein: 35.3,
    fat: 3.9,
    carbohydrates: 1.2,
    calories: 181,
    sugar: null,
  },
  {
    food: "Tamarind",
    type: "Fruits",
    serving: "cup",
    size: 1,
    weight: 120,
    protein: 3.4,
    fat: 0.7,
    carbohydrates: 75,
    calories: 286.8,
    sugar: 68.9,
  },
  {
    food: "Mulberries",
    type: "Fruits",
    serving: "cup",
    size: 1,
    weight: 123,
    protein: 1.5,
    fat: 0.8,
    carbohydrates: 14.7,
    calories: 64,
    sugar: 5.4,
  },
  {
    food: "Toffee Cracker (Tuc)",
    type: "Snacks",
    serving: "piece",
    size: 1,
    weight: 57,
    protein: 3.08,
    fat: 13.4,
    carbohydrates: 37.45,
    calories: 272.46,
    sugar: null,
  },
  {
    food: "Tharid (Traditional)",
    type: "Traditional Dishes",
    serving: "3/4 cup",
    size: 0.75,
    weight: 100,
    protein: 6.8,
    fat: 3.5,
    carbohydrates: 12.1,
    calories: 107,
    sugar: null,
  },
  {
    food: "Garlic",
    type: "Vegetables",
    serving: "3 cloves",
    size: 3,
    weight: 9,
    protein: 0.6,
    fat: null,
    carbohydrates: 3,
    calories: 13.4,
    sugar: 0.1,
  },
  {
    food: "Grated Parmesan Cheese",
    type: "Dairy",
    serving: "tsp",
    size: 1,
    weight: 5,
    protein: 1.9,
    fat: 1.4,
    carbohydrates: 0.2,
    calories: 21.6,
    sugar: null,
  },
  {
    food: "Cheddar Cheese",
    type: "Dairy",
    serving: "2 tbsp",
    size: 2,
    weight: 28,
    protein: 7,
    fat: 9.3,
    carbohydrates: 0.4,
    calories: 112.8,
    sugar: 0.1,
  },
  {
    food: "Halloumi Cheese",
    type: "Dairy",
    serving: "cup",
    size: 1,
    weight: 100,
    protein: 16.4,
    fat: 29.4,
    carbohydrates: 8.2,
    calories: 363,
    sugar: null,
  },
  {
    food: "Hard Goat Cheese",
    type: "Dairy",
    serving: "2 tbsp",
    size: 2,
    weight: 28,
    protein: 8.5,
    fat: 10,
    carbohydrates: 0.6,
    calories: 126.6,
    sugar: 0.6,
  },
  {
    food: "Soft Goat Cheese",
    type: "Dairy",
    serving: "2 tbsp",
    size: 2,
    weight: 28,
    protein: 5.2,
    fat: 5.9,
    carbohydrates: 0.2,
    calories: 75,
    sugar: 0.2,
  },
  {
    food: "Semi-soft Goat Cheese",
    type: "Dairy",
    serving: "2 tbsp",
    size: 2,
    weight: 28,
    protein: 6,
    fat: 8.4,
    carbohydrates: 0.7,
    calories: 101.9,
    sugar: 0.7,
  },
  {
    food: "Low-fat Ricotta Cheese",
    type: "Dairy",
    serving: "cup",
    size: 1,
    weight: 124,
    protein: 14.1,
    fat: 9.8,
    carbohydrates: 6.4,
    calories: 171.1,
    sugar: 0.4,
  },
  {
    food: "Full-fat Ricotta Cheese",
    type: "Dairy",
    serving: "cup",
    size: 1,
    weight: 124,
    protein: 14,
    fat: 16.1,
    carbohydrates: 3.8,
    calories: 215.8,
    sugar: 0.3,
  },
  {
    food: "Feta Cheese",
    type: "Dairy",
    serving: "2 tbsp",
    size: 2,
    weight: 28,
    protein: 4,
    fat: 6,
    carbohydrates: 1.1,
    calories: 73.9,
    sugar: 1.1,
  },
  {
    food: "Cream Cheese",
    type: "Dairy",
    serving: "2 tbsp",
    size: 2,
    weight: 15,
    protein: 0.9,
    fat: 5.1,
    carbohydrates: 0.6,
    calories: 51.3,
    sugar: null,
  },
  {
    food: "Fat-free Cream Cheese",
    type: "Dairy",
    serving: "2 tbsp",
    size: 2,
    weight: 28,
    protein: 4.4,
    fat: 0.3,
    carbohydrates: 2.1,
    calories: 29.4,
    sugar: 0.1,
  },
  {
    food: "Low-fat Cream Cheese",
    type: "Dairy",
    serving: "2 tbsp",
    size: 2,
    weight: 28,
    protein: 2.2,
    fat: 4.3,
    carbohydrates: 2.3,
    calories: 56.3,
    sugar: 0.1,
  },
  {
    food: "Cottage Cheese (<5% fat)",
    type: "Dairy",
    serving: "cup",
    size: 1,
    weight: 226,
    protein: 23.4,
    fat: 0.7,
    carbohydrates: 15.1,
    calories: 162.7,
    sugar: 4.2,
  },
  {
    food: "Full-fat Mozzarella Cheese",
    type: "Dairy",
    serving: "2 tbsp",
    size: 2,
    weight: 28,
    protein: 6.2,
    fat: 6.3,
    carbohydrates: 0.6,
    calories: 84,
    sugar: 0.3,
  },
  {
    food: "Fat-free Mozzarella Cheese",
    type: "Dairy",
    serving: "2 tbsp",
    size: 2,
    weight: 28,
    protein: 8.9,
    fat: 0,
    carbohydrates: 1,
    calories: 41.7,
    sugar: 0.4,
  },
  {
    food: "Low-fat Mozzarella Cheese",
    type: "Dairy",
    serving: "2 tbsp",
    size: 2,
    weight: 28,
    protein: 6.8,
    fat: 4.5,
    carbohydrates: 0.8,
    calories: 71.1,
    sugar: 0.3,
  },
  {
    food: "Grapefruit",
    type: "Fruits",
    serving: "1/2 medium",
    size: 0.5,
    weight: 118,
    protein: 0.7,
    fat: 0.1,
    carbohydrates: 9.5,
    calories: 37.8,
    sugar: 8.2,
  },
  {
    food: "Carrot",
    type: "Vegetables",
    serving: "1 piece",
    size: 1,
    weight: 72,
    protein: 0.7,
    fat: 0.2,
    carbohydrates: 6.9,
    calories: 29.5,
    sugar: 3.3,
  },
  {
    food: "Baby Carrot",
    type: "Vegetables",
    serving: "1 medium",
    size: 1,
    weight: 10,
    protein: 0.1,
    fat: null,
    carbohydrates: 0.8,
    calories: 3.5,
    sugar: 0.5,
  },
  {
    food: "Jalleb (Traditional Dessert)",
    type: "Traditional Dishes",
    serving: "1/2 cup",
    size: 0.5,
    weight: 100,
    protein: 3.1,
    fat: 25,
    carbohydrates: 24,
    calories: 333,
    sugar: null,
  },
  {
    food: "Guava",
    type: "Fruits",
    serving: "1 medium",
    size: 1,
    weight: 90,
    protein: 2.3,
    fat: 0.9,
    carbohydrates: 12.9,
    calories: 61.2,
    sugar: 8,
  },
  {
    food: "Coconut",
    type: "Nuts",
    serving: "2 tbsp",
    size: 2,
    weight: 45,
    protein: 1.5,
    fat: 15.1,
    carbohydrates: 6.9,
    calories: 159.3,
    sugar: 2.8,
  },
  {
    food: "Dried Coconut",
    type: "Nuts",
    serving: "2 tbsp",
    size: 2,
    weight: 28,
    protein: 1.9,
    fat: 18.1,
    carbohydrates: 6.6,
    calories: 184.8,
    sugar: 2.1,
  },
  {
    food: "Corn Kernels",
    type: "Bread & Grains",
    serving: "cup",
    size: 1,
    weight: 166,
    protein: 15.6,
    fat: 7.9,
    carbohydrates: 123.3,
    calories: 605.9,
    sugar: null,
  },
  {
    food: "Wheat Grains",
    type: "Bread & Grains",
    serving: "cup",
    size: 1,
    weight: 192,
    protein: null,
    fat: null,
    carbohydrates: null,
    calories: 0,
    sugar: null,
  },
  {
    food: "Hasoo (Traditional Porridge)",
    type: "Traditional Dishes",
    serving: "1/2 cup",
    size: 0.5,
    weight: 100,
    protein: 2.9,
    fat: 7.1,
    carbohydrates: 14.9,
    calories: 135,
    sugar: null,
  },
  {
    food: "Evaporated Milk",
    type: "Dairy",
    serving: "6 tbsp",
    size: 6,
    weight: 100,
    protein: 7,
    fat: 7.9,
    carbohydrates: 9.7,
    calories: 137,
    sugar: null,
  },
  {
    food: "Sheep Milk",
    type: "Dairy",
    serving: "cup",
    size: 1,
    weight: 245,
    protein: 14.7,
    fat: 17.2,
    carbohydrates: 13.1,
    calories: 264.6,
    sugar: null,
  },
  {
    food: "Goat Milk",
    type: "Dairy",
    serving: "cup",
    size: 1,
    weight: 244,
    protein: 8.7,
    fat: 10.1,
    carbohydrates: 10.9,
    calories: 168.4,
    sugar: 10.9,
  },
  {
    food: "Chocolate Milk Bar",
    type: "Snacks",
    serving: "1 can",
    size: 1,
    weight: 44,
    protein: 3.04,
    fat: 13.46,
    carbohydrates: 26.09,
    calories: 225.72,
    sugar: null,
  },
  {
    food: "Low-fat Chocolate Milk",
    type: "Dairy",
    serving: "cup",
    size: 1,
    weight: 250,
    protein: 7.5,
    fat: 4.8,
    carbohydrates: 30.3,
    calories: 190,
    sugar: 23.9,
  },
  {
    food: "Strawberry Milk",
    type: "Dairy",
    serving: "cup",
    size: 1,
    weight: 266,
    protein: 8,
    fat: 8.2,
    carbohydrates: 32.7,
    calories: 234.1,
    sugar: null,
  },
  {
    food: "Powdered Milk",
    type: "Dairy",
    serving: "2 tbsp",
    size: 2,
    weight: 32,
    protein: 8.4,
    fat: 8.5,
    carbohydrates: 12.3,
    calories: 158.7,
    sugar: 12.3,
  },
  {
    food: "Coconut Milk",
    type: "Beverages",
    serving: "cup",
    size: 1,
    weight: 240,
    protein: 5.5,
    fat: 57.2,
    carbohydrates: 13.3,
    calories: 552,
    sugar: 8,
  },
  {
    food: "Low-fat Milk",
    type: "Dairy",
    serving: "cup",
    size: 1,
    weight: 244,
    protein: 8.1,
    fat: 4.8,
    carbohydrates: 11.4,
    calories: 122,
    sugar: 12.3,
  },
  {
    food: "Whole Milk",
    type: "Dairy",
    serving: "1/3 cup",
    size: 0.3,
    weight: 100,
    protein: 3.5,
    fat: 3,
    carbohydrates: 5.5,
    calories: 64,
    sugar: null,
  },
  {
    food: "Canned Fat-free Evaporated Milk",
    type: "Dairy",
    serving: "2 tbsp",
    size: 2,
    weight: 32,
    protein: 2.4,
    fat: 0.1,
    carbohydrates: 3.6,
    calories: 25,
    sugar: 3.6,
  },
  {
    food: "Sweetened Condensed Milk",
    type: "Dairy",
    serving: "2 tbsp",
    size: 2,
    weight: 38,
    protein: 3,
    fat: 3.3,
    carbohydrates: 20.7,
    calories: 122,
    sugar: 20.7,
  },
  {
    food: "Skimmed Milk",
    type: "Dairy",
    serving: "cup",
    size: 1,
    weight: 245,
    protein: 8.3,
    fat: 0.2,
    carbohydrates: 12.2,
    calories: 83.3,
    sugar: 12.5,
  },
  {
    food: "Pigeon",
    type: "Meats",
    serving: "palm-sized",
    size: 1,
    weight: 100,
    protein: 21.8,
    fat: 3.3,
    carbohydrates: 0,
    calories: 117.8,
    sugar: null,
  },
  {
    food: "Pigeon (skinless)",
    type: "Meats",
    serving: "palm-sized",
    size: 1,
    weight: 85,
    protein: 14.9,
    fat: 6.4,
    carbohydrates: 0,
    calories: 120.7,
    sugar: null,
  },
  {
    food: "Cooked Pigeon",
    type: "Meats",
    serving: "palm-sized",
    size: 1,
    weight: 85,
    protein: 20.3,
    fat: 11,
    carbohydrates: 0,
    calories: 186.2,
    sugar: 0,
  },
  {
    food: "Fried Pigeon",
    type: "Meats",
    serving: "palm-sized",
    size: 1,
    weight: 100,
    protein: 27.8,
    fat: 4.2,
    carbohydrates: 0,
    calories: 150,
    sugar: null,
  },
  {
    food: "Hummus",
    type: "Vegetables",
    serving: "tbsp",
    size: 1,
    weight: 14,
    protein: 1.1,
    fat: 1.3,
    carbohydrates: 2,
    calories: 23.2,
    sugar: null,
  },
  {
    food: "White Bread",
    type: "Bread & Grains",
    serving: "1/4 loaf",
    size: 0.25,
    weight: 25,
    protein: 1.9,
    fat: 0.8,
    carbohydrates: 12.7,
    calories: 66.5,
    sugar: 1.1,
  },
  {
    food: "Toasted White Bread",
    type: "Bread & Grains",
    serving: "1/4 loaf",
    size: 0.25,
    weight: 22,
    protein: 2,
    fat: 0.9,
    carbohydrates: 12,
    calories: 64.5,
    sugar: 1,
  },
  {
    food: "Brown Bread",
    type: "Bread & Grains",
    serving: "1/4 loaf",
    size: 0.25,
    weight: 28,
    protein: 3.6,
    fat: 0.9,
    carbohydrates: 11.6,
    calories: 69.2,
    sugar: 1.6,
  },
  {
    food: "Oat Bread",
    type: "Bread & Grains",
    serving: "small slice",
    size: 1,
    weight: 27,
    protein: 2.3,
    fat: 1.2,
    carbohydrates: 13.1,
    calories: 72.6,
    sugar: 0,
  },
  {
    food: "Oat Bran Bread",
    type: "Bread & Grains",
    serving: "small slice",
    size: 1,
    weight: 30,
    protein: 3.1,
    fat: 1.3,
    carbohydrates: 11.9,
    calories: 70.8,
    sugar: 0,
  },
  {
    food: "Cheese Bread",
    type: "Bread & Grains",
    serving: "piece",
    size: 1,
    weight: 66,
    protein: 4.69,
    fat: 12.08,
    carbohydrates: 28.84,
    calories: 237.6,
    sugar: null,
  },
  {
    food: "Bran Bread",
    type: "Bread & Grains",
    serving: "1/4 loaf",
    size: 0.25,
    weight: 36,
    protein: 3.2,
    fat: 1.2,
    carbohydrates: 17.2,
    calories: 89.3,
    sugar: 3.5,
  },
  {
    food: "White Roll",
    type: "Bread & Grains",
    serving: "1 medium",
    size: 1,
    weight: 28,
    protein: null,
    fat: null,
    carbohydrates: null,
    calories: 0,
    sugar: 2.2,
  },
  {
    food: "Brown Roll",
    type: "Bread & Grains",
    serving: "1 medium",
    size: 1,
    weight: 36,
    protein: null,
    fat: null,
    carbohydrates: null,
    calories: 0,
    sugar: 0.6,
  },
  {
    food: "Burger Bun",
    type: "Bread & Grains",
    serving: "1 piece",
    size: 1,
    weight: 43,
    protein: 4.1,
    fat: 1.9,
    carbohydrates: 21.3,
    calories: 120,
    sugar: 2.3,
  },
  {
    food: "French Bread",
    type: "Bread & Grains",
    serving: "small slice",
    size: 1,
    weight: 32,
    protein: 3.8,
    fat: 0.6,
    carbohydrates: 18.1,
    calories: 92.5,
    sugar: 1.1,
  },
  {
    food: "Khabeesa (Traditional)",
    type: "Traditional Dishes",
    serving: "1/2 cup",
    size: 0.5,
    weight: 100,
    protein: 3.5,
    fat: 6.3,
    carbohydrates: 58.6,
    calories: 305,
    sugar: null,
  },
  {
    food: "Khanfaroush (Traditional)",
    type: "Traditional Dishes",
    serving: "3 pieces",
    size: 3,
    weight: 100,
    protein: 6.3,
    fat: 10.1,
    carbohydrates: 50.1,
    calories: 316,
    sugar: null,
  },
  {
    food: "Cucumber",
    type: "Vegetables",
    serving: "1 large",
    size: 1,
    weight: 301,
    protein: 2,
    fat: 0.3,
    carbohydrates: 10.9,
    calories: 45.2,
    sugar: 5,
  },
  {
    food: "Sour Pickled Cucumber",
    type: "Vegetables",
    serving: "1 slice",
    size: 1,
    weight: 7,
    protein: 0.02,
    fat: 0.01,
    carbohydrates: 0.16,
    calories: 0.77,
    sugar: null,
  },
  {
    food: "Dal (Lentil Curry)",
    type: "Traditional Dishes",
    serving: "1/2 cup",
    size: 0.5,
    weight: 100,
    protein: 4.5,
    fat: 2.5,
    carbohydrates: 13.2,
    calories: 93,
    sugar: null,
  },
  {
    food: "Chicken",
    type: "Meats",
    serving: "palm-sized",
    size: 1,
    weight: 85,
    protein: 18.2,
    fat: 2.6,
    carbohydrates: 0,
    calories: 101.2,
    sugar: 0,
  },
  {
    food: "Canned Chicken",
    type: "Meats",
    serving: "can",
    size: 1,
    weight: 142,
    protein: 30.9,
    fat: 11.3,
    carbohydrates: 0,
    calories: 234.3,
    sugar: 0,
  },
  {
    food: "Oat Flour",
    type: "Bread & Grains",
    serving: "2 tbsp",
    size: 2,
    weight: 28,
    protein: 3.6,
    fat: 1.8,
    carbohydrates: 18.9,
    calories: 105,
    sugar: null,
  },
  {
    food: "Cooked Oat Flour",
    type: "Bread & Grains",
    serving: "cup",
    size: 1,
    weight: 234,
    protein: 5.5,
    fat: 3.2,
    carbohydrates: 27.3,
    calories: 159.1,
    sugar: null,
  },
  {
    food: "Fresh Corn",
    type: "Vegetables",
    serving: "1/2 cup",
    size: 0.5,
    weight: 140,
    protein: 3.68,
    fat: 1.02,
    carbohydrates: 39.07,
    calories: 176.4,
    sugar: null,
  },
  {
    food: "Sweetened Canned Corn",
    type: "Vegetables",
    serving: "cup",
    size: 1,
    weight: 164,
    protein: 4.3,
    fat: 1.64,
    carbohydrates: 30.49,
    calories: 132.84,
    sugar: null,
  },
  {
    food: "Shrimp",
    type: "Meats",
    serving: "5 pieces",
    size: 5,
    weight: 100,
    protein: 19.7,
    fat: 0.8,
    carbohydrates: 0,
    calories: 87.1,
    sugar: null,
  },
  {
    food: "Fried Shrimp",
    type: "Meats",
    serving: "3 medium pieces",
    size: 3,
    weight: 85,
    protein: 18.17,
    fat: 10.43,
    carbohydrates: 9.74,
    calories: 205.71,
    sugar: null,
  },
  {
    food: "Sweetened Corn Flakes",
    type: "Bread & Grains",
    serving: "cup",
    size: 1,
    weight: 38,
    protein: 2.014,
    fat: 0.532,
    carbohydrates: 34.24,
    calories: 148.58,
    sugar: null,
  },
  {
    food: "Plain Corn Flakes",
    type: "Bread & Grains",
    serving: "cup",
    size: 1,
    weight: 28,
    protein: 1.84,
    fat: 0.199,
    carbohydrates: 24.22,
    calories: 102.2,
    sugar: null,
  },
  {
    food: "Yoghurt",
    type: "Dairy",
    serving: "1/3 cup",
    size: 0.3,
    weight: 100,
    protein: 3.2,
    fat: 2.6,
    carbohydrates: 5.4,
    calories: 59,
    sugar: null,
  },
  {
    food: "Low-fat Yoghurt",
    type: "Dairy",
    serving: "cup",
    size: 1,
    weight: 227,
    protein: 11.9,
    fat: 3.5,
    carbohydrates: 16,
    calories: 143,
    sugar: 16,
  },
  {
    food: "Low-fat Vanilla Yoghurt",
    type: "Dairy",
    serving: "cup",
    size: 1,
    weight: 227,
    protein: 11.2,
    fat: 2.8,
    carbohydrates: 31.3,
    calories: 193,
    sugar: 31.3,
  },
  {
    food: "Low-fat Strawberry Yoghurt",
    type: "Dairy",
    serving: "cup",
    size: 1,
    weight: 227,
    protein: 9,
    fat: 2.6,
    carbohydrates: 42.3,
    calories: 224.7,
    sugar: 42.3,
  },
  {
    food: "Fat-free Yoghurt",
    type: "Dairy",
    serving: "cup",
    size: 1,
    weight: 227,
    protein: 13,
    fat: 0.4,
    carbohydrates: 17.4,
    calories: 127.1,
    sugar: 17.4,
  },
  {
    food: "Fat-free Chocolate Yoghurt",
    type: "Dairy",
    serving: "cup",
    size: 1,
    weight: 227,
    protein: 8,
    fat: 0,
    carbohydrates: 53.4,
    calories: 245.2,
    sugar: 34,
  },
  {
    food: "Fat-free Fruit Yoghurt",
    type: "Dairy",
    serving: "cup",
    size: 1,
    weight: 227,
    protein: 10,
    fat: 0.5,
    carbohydrates: 43.1,
    calories: 215.6,
    sugar: 43.1,
  },
  {
    food: "Margarine (unsalted)",
    type: "Fats",
    serving: "tsp",
    size: 1,
    weight: 4.7,
    protein: 0.02,
    fat: 3.77,
    carbohydrates: 0.02,
    calories: 33.56,
    sugar: null,
  },
  {
    food: "Margarine (salted)",
    type: "Fats",
    serving: "tsp",
    size: 1,
    weight: 4.7,
    protein: 0.04,
    fat: 3.78,
    carbohydrates: 0.04,
    calories: 33.78,
    sugar: null,
  },
  {
    food: "Corn Oil",
    type: "Fats",
    serving: "tsp",
    size: 1,
    weight: 13.64,
    protein: 0,
    fat: 13.64,
    carbohydrates: 0,
    calories: 120.55,
    sugar: null,
  },
  {
    food: "Olive Oil",
    type: "Fats",
    serving: "tsp",
    size: 1,
    weight: 13.51,
    protein: 0,
    fat: 13.51,
    carbohydrates: 0,
    calories: 119.44,
    sugar: null,
  },
  {
    food: "Palm Oil",
    type: "Fats",
    serving: "tsp",
    size: 1,
    weight: 13.64,
    protein: 0,
    fat: 13.64,
    carbohydrates: 0,
    calories: 120.55,
    sugar: null,
  },
  {
    food: "Sunflower Oil",
    type: "Fats",
    serving: "tsp",
    size: 1,
    weight: 13.64,
    protein: 0,
    fat: 13.64,
    carbohydrates: 0,
    calories: 120.55,
    sugar: null,
  },
  {
    food: "Canned Olives",
    type: "Vegetables",
    serving: "piece",
    size: 1,
    weight: 8.3,
    protein: 0.08,
    fat: 0.57,
    carbohydrates: 0.47,
    calories: 6.72,
    sugar: null,
  },
  {
    food: "Sago",
    type: "Traditional Dishes",
    serving: "1/2 cup",
    size: 0.5,
    weight: 100,
    protein: 1,
    fat: 2.2,
    carbohydrates: 25.5,
    calories: 126,
    sugar: null,
  },
  {
    food: "Sausage",
    type: "Meats",
    serving: "piece",
    size: 1,
    weight: 57,
    protein: 6.84,
    fat: 16.25,
    carbohydrates: 1.03,
    calories: 179.55,
    sugar: null,
  },
  {
    food: "White Sugar",
    type: "Bread & Grains",
    serving: "tsp",
    size: 1,
    weight: 4,
    protein: 0,
    fat: 0,
    carbohydrates: 3.99,
    calories: 15.48,
    sugar: null,
  },
  {
    food: "Brown Sugar",
    type: "Bread & Grains",
    serving: "tsp",
    size: 1,
    weight: 3,
    protein: 0,
    fat: 0,
    carbohydrates: 2.92,
    calories: 11.28,
    sugar: null,
  },
  {
    food: "Vegetable Salad",
    type: "Vegetables",
    serving: "cup",
    size: 1,
    weight: 100,
    protein: 0.93,
    fat: 1.86,
    carbohydrates: 4.51,
    calories: 39.59,
    sugar: null,
  },
  {
    food: "Canned Salmon",
    type: "Meats",
    serving: "palm-sized",
    size: 1,
    weight: 85,
    protein: 17.4,
    fat: 6.21,
    carbohydrates: 0,
    calories: 130,
    sugar: null,
  },
  {
    food: "Cooked Quail",
    type: "Meats",
    serving: "palm-sized",
    size: 1,
    weight: 85,
    protein: 21.3,
    fat: 12,
    carbohydrates: 0,
    calories: 198.9,
    sugar: 0,
  },
  {
    food: "Cheese Sambusa",
    type: "Traditional Dishes",
    serving: "3 pieces",
    size: 3,
    weight: 100,
    protein: 10.4,
    fat: 19.8,
    carbohydrates: 49.7,
    calories: 418.4,
    sugar: null,
  },
  {
    food: "Vegetable Sambusa",
    type: "Traditional Dishes",
    serving: "4 pieces",
    size: 4,
    weight: 100,
    protein: 5.07,
    fat: 13.61,
    carbohydrates: 33.29,
    calories: 275,
    sugar: null,
  },
  {
    food: "Red Snapper",
    type: "Meats",
    serving: "palm-sized",
    size: 1,
    weight: 85,
    protein: 22.37,
    fat: 1.45,
    carbohydrates: 0,
    calories: 108.81,
    sugar: null,
  },
  {
    food: "Canned Tuna",
    type: "Meats",
    serving: "palm-sized",
    size: 1,
    weight: 85,
    protein: 21.68,
    fat: 0.69,
    carbohydrates: 0,
    calories: 98.61,
    sugar: null,
  },
  {
    food: "Fried Fish",
    type: "Traditional Dishes",
    serving: "1/2 cup",
    size: 0.5,
    weight: 100,
    protein: 23.7,
    fat: 13,
    carbohydrates: null,
    calories: 211,
    sugar: null,
  },
  {
    food: "Snickers",
    type: "Snacks",
    serving: "piece",
    size: 1,
    weight: 61,
    protein: 5.86,
    fat: 13.6,
    carbohydrates: 36.78,
    calories: 277.55,
    sugar: null,
  },
  {
    food: "Tea (unsweetened)",
    type: "Beverages",
    serving: "3/4 cup",
    size: 0.75,
    weight: 236,
    protein: 0,
    fat: 0,
    carbohydrates: 0.06,
    calories: 0.3,
    sugar: null,
  },
  {
    food: "Iced Tea",
    type: "Beverages",
    serving: "cup",
    size: 1,
    weight: 236.6,
    protein: 0,
    fat: 0,
    carbohydrates: 28.59,
    calories: 118.3,
    sugar: null,
  },
  {
    food: "Tea with Sugar",
    type: "Beverages",
    serving: "3/4 cup",
    size: 0.75,
    weight: 236,
    protein: 0.03,
    fat: 0,
    carbohydrates: 2.75,
    calories: 11.01,
    sugar: null,
  },
  {
    food: "Pringles Original",
    type: "Snacks",
    serving: "small can",
    size: 1,
    weight: 50,
    protein: 2.95,
    fat: 19.21,
    carbohydrates: 25.5,
    calories: 278.99,
    sugar: null,
  },
  {
    food: "Cheese Flavour Crisps",
    type: "Snacks",
    serving: "small bag",
    size: 1,
    weight: 25,
    protein: 2.125,
    fat: 6.8,
    carbohydrates: 14.43,
    calories: 124,
    sugar: null,
  },
  {
    food: "Unsalted Crisps",
    type: "Snacks",
    serving: "small bag",
    size: 1,
    weight: 25,
    protein: 1.6,
    fat: 8.84,
    carbohydrates: 12.96,
    calories: 130.75,
    sugar: null,
  },
  {
    food: "Salted Crisps",
    type: "Snacks",
    serving: "small bag",
    size: 1,
    weight: 25,
    protein: 1.75,
    fat: 8.66,
    carbohydrates: 13.23,
    calories: 134,
    sugar: null,
  },
  {
    food: "Puffed Crisps (Meno)",
    type: "Snacks",
    serving: "small bag",
    size: 1,
    weight: 25,
    protein: 1.682,
    fat: 9.525,
    carbohydrates: 12.889,
    calories: 137.94,
    sugar: null,
  },
  {
    food: "Orange Syrup Drink",
    type: "Beverages",
    serving: "3/4 cup",
    size: 0.75,
    weight: 247.79,
    protein: 0,
    fat: 0,
    carbohydrates: 31.96,
    calories: 126.37,
    sugar: null,
  },
  {
    food: "Fruit Flavour Drink",
    type: "Beverages",
    serving: "cup",
    size: 1,
    weight: 192,
    protein: 2.11,
    fat: 3.84,
    carbohydrates: 58.37,
    calories: 264.96,
    sugar: null,
  },
  {
    food: "Grape Syrup Drink",
    type: "Beverages",
    serving: "3/4 cup",
    size: 0.75,
    weight: 250.18,
    protein: 0,
    fat: 0,
    carbohydrates: 28.77,
    calories: 112.58,
    sugar: null,
  },
  {
    food: "Lemon Syrup Drink",
    type: "Beverages",
    serving: "cup",
    size: 1,
    weight: 266,
    protein: 0,
    fat: 0,
    carbohydrates: 28.73,
    calories: 11172,
    sugar: null,
  },
  {
    food: "Sha'ri Fish",
    type: "Meats",
    serving: "palm-sized",
    size: 1,
    weight: 100,
    protein: 19.7,
    fat: 1.1,
    carbohydrates: 0,
    calories: 89.8,
    sugar: null,
  },
  {
    food: "Fried Sha'ri Fish",
    type: "Meats",
    serving: "palm-sized",
    size: 1,
    weight: 100,
    protein: 25.9,
    fat: 7,
    carbohydrates: 0,
    calories: 167,
    sugar: null,
  },
  {
    food: "Beetroot",
    type: "Vegetables",
    serving: "slices (1/2 cup)",
    size: 0.5,
    weight: 68,
    protein: 1.1,
    fat: 0.1,
    carbohydrates: 6.5,
    calories: 29.2,
    sugar: 4.6,
  },
  {
    food: "Chicken Shawarma",
    type: "Traditional Dishes",
    serving: "1 piece",
    size: 1,
    weight: 100,
    protein: 20.6,
    fat: 5.2,
    carbohydrates: 23.9,
    calories: 224.9,
    sugar: null,
  },
  {
    food: "Meat Shawarma",
    type: "Traditional Dishes",
    serving: "1 piece",
    size: 1,
    weight: 100,
    protein: 20,
    fat: 6.4,
    carbohydrates: 22.2,
    calories: 227.2,
    sugar: null,
  },
  {
    food: "Quaker Oats",
    type: "Bread & Grains",
    serving: "2.5 tsp",
    size: 2.5,
    weight: 40,
    protein: 6.8,
    fat: 3.2,
    carbohydrates: 25.2,
    calories: 145.6,
    sugar: null,
  },
  {
    food: "Quaker Oats (cooked with water)",
    type: "Bread & Grains",
    serving: "cup",
    size: 1,
    weight: 234,
    protein: 4.8,
    fat: 2.2,
    carbohydrates: 17.5,
    calories: 100.6,
    sugar: null,
  },
  {
    food: "Cooked Oats",
    type: "Bread & Grains",
    serving: "cup",
    size: 1,
    weight: 219,
    protein: 7,
    fat: 1.9,
    carbohydrates: 25.1,
    calories: 87.6,
    sugar: null,
  },
  {
    food: "Banana Chips",
    type: "Snacks",
    serving: "2 tbsp",
    size: 2,
    weight: 28,
    protein: 0.6,
    fat: 9.4,
    carbohydrates: 16.4,
    calories: 145.3,
    sugar: 9.9,
  },
  {
    food: "Safi Fish",
    type: "Meats",
    serving: "palm-sized",
    size: 1,
    weight: 100,
    protein: 18.9,
    fat: 7.3,
    carbohydrates: 0.1,
    calories: 141.8,
    sugar: null,
  },
  {
    food: "Grilled Safi Fish",
    type: "Meats",
    serving: "palm-sized",
    size: 1,
    weight: 100,
    protein: 27.3,
    fat: 4.3,
    carbohydrates: 0,
    calories: 148.9,
    sugar: null,
  },
  {
    food: "Broasted Chicken Breast",
    type: "Meats",
    serving: "½ small chicken breast",
    size: 0.5,
    weight: 85,
    protein: 26.35,
    fat: 3,
    carbohydrates: 0,
    calories: 140.26,
    sugar: null,
  },
  {
    food: "Fried Chicken Breast",
    type: "Meats",
    serving: "½ small chicken breast",
    size: 0.5,
    weight: 85,
    protein: 28.42,
    fat: 4,
    carbohydrates: 0.42,
    calories: 158.94,
    sugar: null,
  },
  {
    food: "Egg Yolk",
    type: "Eggs",
    serving: "1 egg yolk",
    size: 1,
    weight: 17,
    protein: 2.7,
    fat: 4.5,
    carbohydrates: 0.6,
    calories: 53.9,
    sugar: 0.1,
  },
  {
    food: "White Flour",
    type: "Bread & Grains",
    serving: "1 cup",
    size: 1,
    weight: 125,
    protein: 12.19,
    fat: 1.23,
    carbohydrates: 95.39,
    calories: 455,
    sugar: null,
  },
  {
    food: "Corn Flour",
    type: "Bread & Grains",
    serving: "cup",
    size: 1,
    weight: 114,
    protein: null,
    fat: null,
    carbohydrates: null,
    calories: 0,
    sugar: 0.2,
  },
  {
    food: "White Rice Flour",
    type: "Bread & Grains",
    serving: "cup",
    size: 1,
    weight: 158,
    protein: 9.4,
    fat: 2.2,
    carbohydrates: 126.6,
    calories: 578.3,
    sugar: null,
  },
  {
    food: "Brown Rice Flour",
    type: "Bread & Grains",
    serving: "cup",
    size: 1,
    weight: 158,
    protein: 11.4,
    fat: 4.4,
    carbohydrates: 120.8,
    calories: 573.5,
    sugar: 0.5,
  },
  {
    food: "Whole Wheat Flour",
    type: "Bread & Grains",
    serving: "cup",
    size: 1,
    weight: 120,
    protein: 16.4,
    fat: 2.2,
    carbohydrates: 87.1,
    calories: 406.8,
    sugar: 6.7,
  },
  {
    food: "Falafel",
    type: "Vegetables",
    serving: "1 piece",
    size: 1,
    weight: 17,
    protein: 2.3,
    fat: 3,
    carbohydrates: 5.4,
    calories: 56.6,
    sugar: null,
  },
  {
    food: "Tomato",
    type: "Vegetables",
    serving: "1 medium",
    size: 1,
    weight: 123,
    protein: 1.1,
    fat: 0.2,
    carbohydrates: 4.8,
    calories: 22.1,
    sugar: 3.2,
  },
  {
    food: "Lentils",
    type: "Vegetables",
    serving: "cup",
    size: 1,
    weight: 198,
    protein: 17.9,
    fat: 0.8,
    carbohydrates: 39.9,
    calories: 229.7,
    sugar: 3.6,
  },
  {
    food: "Honey",
    type: "Bread & Grains",
    serving: "tbsp",
    size: 1,
    weight: 21,
    protein: 0.06,
    fat: 0,
    carbohydrates: 17.3,
    calories: 63.84,
    sugar: null,
  },
  {
    food: "Aseedah (Traditional)",
    type: "Traditional Dishes",
    serving: "1/2 cup",
    size: 0.5,
    weight: 100,
    protein: 4.3,
    fat: 11.9,
    carbohydrates: 29.6,
    calories: 243,
    sugar: null,
  },
  {
    food: "Pineapple Juice",
    type: "Beverages",
    serving: "cup",
    size: 1,
    weight: 250.17,
    protein: 0.8,
    fat: 0.2,
    carbohydrates: 34.48,
    calories: 140.11,
    sugar: null,
  },
  {
    food: "Orange Juice",
    type: "Beverages",
    serving: "3/4 cup",
    size: 0.75,
    weight: 248,
    protein: 1.74,
    fat: 0.5,
    carbohydrates: 25.79,
    calories: 111.6,
    sugar: null,
  },
  {
    food: "Orange & Apricot Juice",
    type: "Beverages",
    serving: "3/4 cup",
    size: 0.75,
    weight: 249.39,
    protein: 0.75,
    fat: 0.25,
    carbohydrates: 31.67,
    calories: 127.19,
    sugar: null,
  },
  {
    food: "Unsweetened Apple Juice",
    type: "Beverages",
    serving: "3/4 cup",
    size: 0.75,
    weight: 247.79,
    protein: 0.15,
    fat: 0.27,
    carbohydrates: 28.94,
    calories: 116.46,
    sugar: null,
  },
  {
    food: "Unsweetened Grapefruit Juice",
    type: "Beverages",
    serving: "3/4 cup",
    size: 0.75,
    weight: 246.99,
    protein: 1.28,
    fat: 0.25,
    carbohydrates: 22.13,
    calories: 93.86,
    sugar: null,
  },
  {
    food: "Sweetened Grapefruit Juice",
    type: "Beverages",
    serving: "3/4 cup",
    size: 0.75,
    weight: 249.39,
    protein: 1.45,
    fat: 0.22,
    carbohydrates: 27.76,
    calories: 114.72,
    sugar: null,
  },
  {
    food: "Carrot Juice",
    type: "Beverages",
    serving: "3/4 cup",
    size: 0.75,
    weight: 246,
    protein: 2.34,
    fat: 0.37,
    carbohydrates: 22.88,
    calories: 98.4,
    sugar: null,
  },
  {
    food: "Guava Juice",
    type: "Beverages",
    serving: "3/4 cup",
    size: 0.75,
    weight: 239.91,
    protein: 0,
    fat: 0,
    carbohydrates: 21.63,
    calories: 87.86,
    sugar: null,
  },
  {
    food: "Tomato Juice",
    type: "Beverages",
    serving: "cup",
    size: 1,
    weight: 244,
    protein: 1.8,
    fat: 0.15,
    carbohydrates: 10.32,
    calories: 41.48,
    sugar: null,
  },
  {
    food: "Mixed Fruit Juice",
    type: "Beverages",
    serving: "cup",
    size: 1,
    weight: 255,
    protein: 0.99,
    fat: 0.18,
    carbohydrates: 48.22,
    calories: 186.15,
    sugar: null,
  },
  {
    food: "Pear Juice",
    type: "Beverages",
    serving: "cup",
    size: 1,
    weight: 255.78,
    protein: 1.56,
    fat: 0.08,
    carbohydrates: 44.63,
    calories: 181.61,
    sugar: null,
  },
  {
    food: "Mango Juice",
    type: "Beverages",
    serving: "3/4 cup",
    size: 0.75,
    weight: 239.91,
    protein: 0,
    fat: 0,
    carbohydrates: 21.63,
    calories: 87.86,
    sugar: null,
  },
  {
    food: "Apricot Juice",
    type: "Beverages",
    serving: "cup",
    size: 1,
    weight: 258,
    protein: 1.23,
    fat: 0.23,
    carbohydrates: 55.34,
    calories: 214.14,
    sugar: null,
  },
  {
    food: "Aqeeli (Traditional Bread)",
    type: "Traditional Dishes",
    serving: "slice",
    size: 1,
    weight: 100,
    protein: 10.1,
    fat: 9.4,
    carbohydrates: 56.7,
    calories: 352,
    sugar: null,
  },
  {
    food: "Aysh Shaylani (Traditional)",
    type: "Traditional Dishes",
    serving: "1/2 cup",
    size: 0.5,
    weight: 100,
    protein: 3.1,
    fat: 3.8,
    carbohydrates: 31.3,
    calories: 172,
    sugar: null,
  },
  {
    food: "Gouj (Traditional Fruit)",
    type: "Fruits",
    serving: "1 medium",
    size: 1,
    weight: 66,
    protein: 0.5,
    fat: 0.2,
    carbohydrates: 7.5,
    calories: 30.4,
    sugar: 6.5,
  },
  {
    food: "Chicken Ghouzi",
    type: "Traditional Dishes",
    serving: "1/2 cup",
    size: 0.5,
    weight: 100,
    protein: 10.11,
    fat: 3.3,
    carbohydrates: 22.68,
    calories: 160.8,
    sugar: null,
  },
  {
    food: "Lamb Ghouzi",
    type: "Traditional Dishes",
    serving: "1/2 cup",
    size: 0.5,
    weight: 100,
    protein: 11.4,
    fat: 3.4,
    carbohydrates: 22.4,
    calories: 166.9,
    sugar: null,
  },
  {
    food: "White Beans",
    type: "Vegetables",
    serving: "cup",
    size: 1,
    weight: 179,
    protein: 17.4,
    fat: 0.6,
    carbohydrates: 44.9,
    calories: 248.8,
    sugar: 0.6,
  },
  {
    food: "Yellow Beans",
    type: "Vegetables",
    serving: "cup",
    size: 1,
    weight: 177,
    protein: 16.2,
    fat: 1.9,
    carbohydrates: 44.7,
    calories: 254.9,
    sugar: null,
  },
  {
    food: "Faloodeh (Traditional Dessert)",
    type: "Traditional Dishes",
    serving: "2/3 cup",
    size: 0.67,
    weight: 100,
    protein: 0.9,
    fat: 0.9,
    carbohydrates: 18.4,
    calories: 85,
    sugar: null,
  },
  {
    food: "Fried Chicken Thigh",
    type: "Meats",
    serving: "medium chicken thigh",
    size: 1,
    weight: 85,
    protein: 18.5,
    fat: 13.73,
    carbohydrates: 7.41,
    calories: 232,
    sugar: null,
  },
  {
    food: "Broasted Chicken Thigh",
    type: "Meats",
    serving: "medium chicken thigh",
    size: 1,
    weight: 85,
    protein: 22,
    fat: 11.45,
    carbohydrates: 0,
    calories: 197.19,
    sugar: null,
  },
  {
    food: "Fried Chicken Thigh",
    type: "Meats",
    serving: "medium chicken thigh",
    size: 1,
    weight: 85,
    protein: 18.5,
    fat: 13.73,
    carbohydrates: 7.41,
    calories: 232,
    sugar: null,
  },
  {
    food: "Strawberries",
    type: "Fruits",
    serving: "cup",
    size: 1,
    weight: 144,
    protein: 1,
    fat: 0.4,
    carbohydrates: 11.1,
    calories: 46.1,
    sugar: 6.7,
  },
  {
    food: "Dried Pistachios",
    type: "Nuts",
    serving: "2 tbsp",
    size: 2,
    weight: 28,
    protein: 5.8,
    fat: 12.4,
    carbohydrates: 7.8,
    calories: 156,
    sugar: 2.9,
  },
  {
    food: "Dry-roasted Pistachios",
    type: "Nuts",
    serving: "2 tbsp (47 pieces)",
    size: 2,
    weight: 28,
    protein: 6,
    fat: 12.9,
    carbohydrates: 7.7,
    calories: 159.9,
    sugar: 2.9,
  },
  {
    food: "Red Chilli Pepper",
    type: "Vegetables",
    serving: "piece",
    size: 1,
    weight: 45,
    protein: 0.8,
    fat: 0.2,
    carbohydrates: 4,
    calories: 18,
    sugar: 2.4,
  },
  {
    food: "Green Chilli Pepper",
    type: "Vegetables",
    serving: "piece",
    size: 1,
    weight: 45,
    protein: 0.9,
    fat: 0.1,
    carbohydrates: 4.3,
    calories: 18,
    sugar: 2.3,
  },
  {
    food: "Soybeans",
    type: "Nuts",
    serving: "cup",
    size: 1,
    weight: 172,
    protein: 28.6,
    fat: 15.4,
    carbohydrates: 17.1,
    calories: 297.6,
    sugar: 5.2,
  },
  {
    food: "Roasted Soybeans",
    type: "Nuts",
    serving: "cup",
    size: 1,
    weight: 172,
    protein: 60.6,
    fat: 43.7,
    carbohydrates: 57.7,
    calories: 810.1,
    sugar: 30.4,
  },
  {
    food: "Dry-roasted Soybeans",
    type: "Nuts",
    serving: "2 tbsp",
    size: 2,
    weight: 28,
    protein: 11.1,
    fat: 6.1,
    carbohydrates: 9.2,
    calories: 126.3,
    sugar: 2.3,
  },
  {
    food: "Qurs Tabi (Traditional)",
    type: "Traditional Dishes",
    serving: "4 pieces",
    size: 4,
    weight: 100,
    protein: 6.7,
    fat: 18.9,
    carbohydrates: 36.9,
    calories: 345,
    sugar: null,
  },
  {
    food: "Qurqufan Fish",
    type: "Meats",
    serving: "palm-sized",
    size: 1,
    weight: 100,
    protein: 19.9,
    fat: 3.7,
    carbohydrates: 0.4,
    calories: 115,
    sugar: null,
  },
  {
    food: "Grilled Qurqufan Fish",
    type: "Meats",
    serving: "palm-sized",
    size: 1,
    weight: 100,
    protein: 22.8,
    fat: 1.8,
    carbohydrates: 0,
    calories: 108.6,
    sugar: null,
  },
  {
    food: "Orange Zest",
    type: "Fruits",
    serving: "tsp",
    size: 1,
    weight: 6,
    protein: 0.1,
    fat: null,
    carbohydrates: 1.5,
    calories: 5.8,
    sugar: null,
  },
  {
    food: "Lemon Zest",
    type: "Fruits",
    serving: "tsp",
    size: 1,
    weight: 6,
    protein: 0.1,
    fat: null,
    carbohydrates: 1,
    calories: 2.8,
    sugar: 0.3,
  },
  {
    food: "Croutons",
    type: "Bread & Grains",
    serving: "cup",
    size: 1,
    weight: 30,
    protein: 3.6,
    fat: 2,
    carbohydrates: 22,
    calories: 122.1,
    sugar: null,
  },
  {
    food: "Taro",
    type: "Vegetables",
    serving: "cup",
    size: 1,
    weight: 104,
    protein: 1.6,
    fat: 0.2,
    carbohydrates: 27.5,
    calories: 116.5,
    sugar: 0.4,
  },
  {
    food: "Instant Coffee",
    type: "Beverages",
    serving: "1.5 cups",
    size: 1.5,
    weight: 29.86,
    protein: 0.03,
    fat: 0,
    carbohydrates: 0.12,
    calories: 0.6,
    sugar: null,
  },
  {
    food: "Cappuccino",
    type: "Beverages",
    serving: "1.5 cups",
    size: 1.5,
    weight: 29.3,
    protein: 0.06,
    fat: 0.32,
    carbohydrates: 1.64,
    calories: 9.38,
    sugar: null,
  },
  {
    food: "Qeema (Minced Meat Dish)",
    type: "Traditional Dishes",
    serving: "1/2 cup",
    size: 0.5,
    weight: 100,
    protein: 7.5,
    fat: 4.5,
    carbohydrates: 7.4,
    calories: 100,
    sugar: null,
  },
  {
    food: "Chicken Curry",
    type: "Traditional Dishes",
    serving: "1/2 cup",
    size: 0.5,
    weight: 100,
    protein: 9.7,
    fat: 1.5,
    carbohydrates: 8,
    calories: 84.7,
    sugar: null,
  },
  {
    food: "Fish Curry",
    type: "Traditional Dishes",
    serving: "1/2 cup",
    size: 0.5,
    weight: 100,
    protein: 13,
    fat: 2,
    carbohydrates: 3.8,
    calories: 86.6,
    sugar: null,
  },
  {
    food: "Meat Curry",
    type: "Traditional Dishes",
    serving: "1/2 cup",
    size: 0.5,
    weight: 100,
    protein: 15.3,
    fat: 2.8,
    carbohydrates: 3,
    calories: 99.4,
    sugar: null,
  },
  {
    food: "Kastar (Traditional)",
    type: "Traditional Dishes",
    serving: "1/2 cup",
    size: 0.5,
    weight: 100,
    protein: 2.8,
    fat: 3.1,
    carbohydrates: 12.6,
    calories: 90,
    sugar: null,
  },
  {
    food: "Kebab",
    type: "Traditional Dishes",
    serving: "4 pieces",
    size: 4,
    weight: 100,
    protein: 8.1,
    fat: 12.6,
    carbohydrates: 33.7,
    calories: 281,
    sugar: null,
  },
  {
    food: "Lamb Kebab",
    type: "Traditional Dishes",
    serving: "palm-sized (pieces)",
    size: 1,
    weight: 100,
    protein: 25.16,
    fat: 12.96,
    carbohydrates: 1.55,
    calories: 223,
    sugar: null,
  },
  {
    food: "Chicken Liver",
    type: "Meats",
    serving: "3 medium pieces",
    size: 3,
    weight: 85,
    protein: 20.72,
    fat: 4.65,
    carbohydrates: 0.75,
    calories: 133.5,
    sugar: null,
  },
  {
    food: "Cooked Beef Liver",
    type: "Meats",
    serving: "4 medium pieces",
    size: 4,
    weight: 85,
    protein: 22.73,
    fat: 6.81,
    carbohydrates: 6.67,
    calories: 184.45,
    sugar: null,
  },
  {
    food: "Chives / Spring Onion",
    type: "Vegetables",
    serving: "bunch (cup)",
    size: 1,
    weight: 89,
    protein: 1.3,
    fat: 0.3,
    carbohydrates: 12.6,
    calories: 54.3,
    sugar: 3.5,
  },
  {
    food: "Celery",
    type: "Vegetables",
    serving: "1 medium",
    size: 1,
    weight: 40,
    protein: 0.3,
    fat: 0.1,
    carbohydrates: 1.2,
    calories: 6.4,
    sugar: 0.7,
  },
  {
    food: "Cheese Croissant",
    type: "Bread & Grains",
    serving: "medium piece",
    size: 1,
    weight: 57,
    protein: 5.24,
    fat: 11.91,
    carbohydrates: 26.79,
    calories: 235.98,
    sugar: null,
  },
  {
    food: "Butter Croissant",
    type: "Bread & Grains",
    serving: "medium piece",
    size: 1,
    weight: 57,
    protein: 4.67,
    fat: 11.97,
    carbohydrates: 26.11,
    calories: 231.42,
    sugar: null,
  },
  {
    food: "Coffee Creamer (light)",
    type: "Creams",
    serving: "tbsp",
    size: 1,
    weight: 15,
    protein: 0.4,
    fat: 2.9,
    carbohydrates: 0.5,
    calories: 29.2,
    sugar: null,
  },
  {
    food: "Powdered Cream",
    type: "Creams",
    serving: "tbsp",
    size: 1,
    weight: 6,
    protein: 0.3,
    fat: 2.1,
    carbohydrates: 3.3,
    calories: 32.7,
    sugar: 3.3,
  },
  {
    food: "Low-fat Powdered Cream",
    type: "Creams",
    serving: "tbsp",
    size: 1,
    weight: 6,
    protein: 0.1,
    fat: 0.9,
    carbohydrates: 4.4,
    calories: 25.9,
    sugar: 4.4,
  },
  {
    food: "Fat-free Sour Cream",
    type: "Creams",
    serving: "2 tbsp",
    size: 2,
    weight: 30,
    protein: 0.9,
    fat: 0,
    carbohydrates: 4.7,
    calories: 22.2,
    sugar: 0.1,
  },
  {
    food: "Low-fat Sour Cream",
    type: "Creams",
    serving: "2 tbsp",
    size: 2,
    weight: 30,
    protein: 2.1,
    fat: 4.2,
    carbohydrates: 2.1,
    calories: 54.3,
    sugar: 0.1,
  },
  {
    food: "Liquid Cream (light)",
    type: "Creams",
    serving: "tbsp",
    size: 1,
    weight: 30,
    protein: 0.2,
    fat: 1,
    carbohydrates: 2.7,
    calories: 21.3,
    sugar: 2.7,
  },
  {
    food: "Pear",
    type: "Fruits",
    serving: "1 medium",
    size: 1,
    weight: 166,
    protein: 0.6,
    fat: 0.2,
    carbohydrates: 25.7,
    calories: 96.3,
    sugar: 16.3,
  },
  {
    food: "Dried Pear",
    type: "Fruits",
    serving: "10 halves",
    size: 10,
    weight: 175,
    protein: 3.3,
    fat: 1.1,
    carbohydrates: 122,
    calories: 458.5,
    sugar: 108.8,
  },
  {
    food: "Kingfish (Kanaad)",
    type: "Meats",
    serving: "palm-sized",
    size: 1,
    weight: 100,
    protein: 19.5,
    fat: 9.3,
    carbohydrates: 0,
    calories: 161,
    sugar: null,
  },
  {
    food: "Fried Kingfish",
    type: "Meats",
    serving: "palm-sized",
    size: 1,
    weight: 100,
    protein: 26.7,
    fat: 11.9,
    carbohydrates: 0,
    calories: 213.7,
    sugar: null,
  },
  {
    food: "Diet Cola",
    type: "Beverages",
    serving: "1.5 cups",
    size: 1.5,
    weight: 369,
    protein: 0.2,
    fat: 0,
    carbohydrates: 0.3,
    calories: 2,
    sugar: null,
  },
  {
    food: "Regular Cola",
    type: "Beverages",
    serving: "1.5 cups",
    size: 1.5,
    weight: 369,
    protein: 0.1,
    fat: 0.1,
    carbohydrates: 38.5,
    calories: 151,
    sugar: null,
  },
  {
    food: "KitKat",
    type: "Snacks",
    serving: "1 piece",
    size: 1,
    weight: 46,
    protein: 3.08,
    fat: 13.11,
    carbohydrates: 28.47,
    calories: 234.6,
    sugar: null,
  },
  {
    food: "Plain Muffin",
    type: "Bread & Grains",
    serving: "large",
    size: 1,
    weight: 65,
    protein: 4.49,
    fat: 7.41,
    carbohydrates: 26.91,
    calories: 192.4,
    sugar: null,
  },
  {
    food: "Quinoa",
    type: "Bread & Grains",
    serving: "cup",
    size: 1,
    weight: 170,
    protein: 24,
    fat: 10.3,
    carbohydrates: 109.1,
    calories: 625.6,
    sugar: null,
  },
  {
    food: "Kiwi",
    type: "Fruits",
    serving: "1 medium",
    size: 1,
    weight: 76,
    protein: 0.9,
    fat: 0.4,
    carbohydrates: 11.1,
    calories: 46.4,
    sugar: 6.8,
  },
  {
    food: "Labneh",
    type: "Dairy",
    serving: "cup",
    size: 1,
    weight: 100,
    protein: 12.9,
    fat: 10.8,
    carbohydrates: 1,
    calories: 154,
    sugar: null,
  },
  {
    food: "Boiled Ground Beef",
    type: "Meats",
    serving: "2 tbsp",
    size: 2,
    weight: 85,
    protein: 20.45,
    fat: 17.6,
    carbohydrates: 0,
    calories: 245.65,
    sugar: null,
  },
  {
    food: "Fried Ground Beef",
    type: "Meats",
    serving: "2 tbsp",
    size: 2,
    weight: 85,
    protein: 20.33,
    fat: 19.2,
    carbohydrates: 0,
    calories: 260,
    sugar: null,
  },
  {
    food: "Cooked Veal",
    type: "Meats",
    serving: "3 small pieces",
    size: 3,
    weight: 85,
    protein: 23.99,
    fat: 8,
    carbohydrates: 0,
    calories: 175,
    sugar: null,
  },
  {
    food: "Luqaimat (Traditional Dumplings)",
    type: "Traditional Dishes",
    serving: "5 pieces",
    size: 5,
    weight: 100,
    protein: 3,
    fat: 9.5,
    carbohydrates: 44.4,
    calories: 275,
    sugar: null,
  },
  {
    food: "Almonds",
    type: "Nuts",
    serving: "2 tbsp",
    size: 2,
    weight: 28,
    protein: 5.9,
    fat: 13.8,
    carbohydrates: 6.1,
    calories: 161,
    sugar: 1.3,
  },
  {
    food: "Lemon",
    type: "Fruits",
    serving: "1 medium",
    size: 1,
    weight: 58,
    protein: 0.6,
    fat: 0.2,
    carbohydrates: 5.4,
    calories: 16.8,
    sugar: 1.4,
  },
  {
    food: "Lemon Soda",
    type: "Beverages",
    serving: "1.5 cups",
    size: 1.5,
    weight: 355,
    protein: 0,
    fat: 0,
    carbohydrates: 38.4,
    calories: 149,
    sugar: null,
  },
  {
    food: "Coconut Water",
    type: "Beverages",
    serving: "cup",
    size: 1,
    weight: 240,
    protein: 1.7,
    fat: 0.5,
    carbohydrates: 8.9,
    calories: 45.6,
    sugar: 6.3,
  },
  {
    food: "Mango",
    type: "Fruits",
    serving: "1 medium",
    size: 1,
    weight: 207,
    protein: 1.1,
    fat: 0.6,
    carbohydrates: 35.2,
    calories: 134.6,
    sugar: 30.6,
  },
  {
    food: "Mayonnaise",
    type: "Fats",
    serving: "tsp",
    size: 1,
    weight: 14.7,
    protein: 0.13,
    fat: 4.91,
    carbohydrates: 3.51,
    calories: 57.29,
    sugar: null,
  },
  {
    food: "Chicken Machboos",
    type: "Traditional Dishes",
    serving: "1/2 cup",
    size: 0.5,
    weight: 100,
    protein: 17,
    fat: 2.39,
    carbohydrates: 17.2,
    calories: 158.36,
    sugar: null,
  },
  {
    food: "Lamb Machboos",
    type: "Traditional Dishes",
    serving: "1/2 cup",
    size: 0.5,
    weight: 100,
    protein: 16.89,
    fat: 3,
    carbohydrates: 16.87,
    calories: 166.5,
    sugar: null,
  },
  {
    food: "Stuffed Zucchini",
    type: "Traditional Dishes",
    serving: "piece",
    size: 1,
    weight: 100,
    protein: 4.86,
    fat: 1.51,
    carbohydrates: 14.67,
    calories: 86.37,
    sugar: null,
  },
  {
    food: "Stuffed Grape Leaves",
    type: "Traditional Dishes",
    serving: "4 pieces",
    size: 4,
    weight: 100,
    protein: 7.47,
    fat: 2.73,
    carbohydrates: 16.11,
    calories: 125.2,
    sugar: null,
  },
  {
    food: "Muhallabia (Milk Pudding)",
    type: "Traditional Dishes",
    serving: "2/3 cup",
    size: 0.67,
    weight: 100,
    protein: 2.9,
    fat: 2.9,
    carbohydrates: 17.6,
    calories: 108,
    sugar: null,
  },
  {
    food: "Fish Broth",
    type: "Traditional Dishes",
    serving: "1/2",
    size: 0.5,
    weight: 100,
    protein: 7,
    fat: 5.8,
    carbohydrates: 0.5,
    calories: 82,
    sugar: null,
  },
  {
    food: "Mushroom",
    type: "Vegetables",
    serving: "cup",
    size: 1,
    weight: 70,
    protein: 2.2,
    fat: 0.2,
    carbohydrates: 2.3,
    calories: 15.4,
    sugar: 1.2,
  },
  {
    food: "Apricot",
    type: "Fruits",
    serving: "3 pieces",
    size: 3,
    weight: 105,
    protein: 1.5,
    fat: 0.4,
    carbohydrates: 11.7,
    calories: 50.4,
    sugar: 9.7,
  },
  {
    food: "Dried Apricot",
    type: "Fruits",
    serving: "cup",
    size: 1,
    weight: 65,
    protein: 2.2,
    fat: 0.3,
    carbohydrates: 40.7,
    calories: 156.6,
    sugar: 34.7,
  },
  {
    food: "Madrouba (Traditional)",
    type: "Traditional Dishes",
    serving: "1/2",
    size: 0.5,
    weight: 100,
    protein: 8.55,
    fat: 0.9,
    carbohydrates: 5.34,
    calories: 63.6,
    sugar: null,
  },
  {
    food: "Tomato Paste",
    type: "Vegetables",
    serving: "168g (can)",
    size: 1,
    weight: 170,
    protein: 7.3,
    fat: 0.8,
    carbohydrates: 32.1,
    calories: 139.4,
    sugar: 17.7,
  },
  {
    food: "Chicken Pasta",
    type: "Traditional Dishes",
    serving: "1/2 cup",
    size: 0.5,
    weight: 100,
    protein: 17.9,
    fat: 1.9,
    carbohydrates: 10,
    calories: 129.7,
    sugar: null,
  },
  {
    food: "Cooked Pasta",
    type: "Bread & Grains",
    serving: "cup",
    size: 1,
    weight: 140,
    protein: 6.68,
    fat: 0.94,
    carbohydrates: 39.68,
    calories: 197.4,
    sugar: null,
  },
  {
    food: "Corn Nuts",
    type: "Nuts",
    serving: "2 tbsp",
    size: 2,
    weight: 28,
    protein: 2.4,
    fat: 4.4,
    carbohydrates: 20.1,
    calories: 124.9,
    sugar: 0.2,
  },
  {
    food: "Mixed Roasted Nuts",
    type: "Nuts",
    serving: "1/8 cup",
    size: 0.125,
    weight: 28,
    protein: 4.8,
    fat: 14.4,
    carbohydrates: 7.1,
    calories: 166.3,
    sugar: 2.5,
  },
  {
    food: "Mixed Oil-roasted Nuts",
    type: "Nuts",
    serving: "1/8 cup",
    size: 0.125,
    weight: 28,
    protein: 4.7,
    fat: 15.8,
    carbohydrates: 6,
    calories: 172.8,
    sugar: 2.8,
  },
  {
    food: "Chicken Mandi",
    type: "Traditional Dishes",
    serving: "1/2 cup",
    size: 0.5,
    weight: 100,
    protein: 14.6,
    fat: 2.3,
    carbohydrates: 17.9,
    calories: 154.9,
    sugar: null,
  },
  {
    food: "Lamb Mandi",
    type: "Traditional Dishes",
    serving: "1/2 cup",
    size: 0.5,
    weight: 100,
    protein: 11.9,
    fat: 1.9,
    carbohydrates: 20.34,
    calories: 147,
    sugar: null,
  },
  {
    food: "Banana",
    type: "Fruits",
    serving: "1 medium",
    size: 1,
    weight: 118,
    protein: 1.3,
    fat: 0.4,
    carbohydrates: 27,
    calories: 105,
    sugar: 14.4,
  },
  {
    food: "Meid Fish",
    type: "Meats",
    serving: "palm-sized",
    size: 1,
    weight: 100,
    protein: 18.3,
    fat: 16.1,
    carbohydrates: 0,
    calories: 216.7,
    sugar: null,
  },
  {
    food: "Grilled Meid Fish",
    type: "Meats",
    serving: "palm-sized",
    size: 1,
    weight: 100,
    protein: 24.2,
    fat: 10.5,
    carbohydrates: 0,
    calories: 191.2,
    sugar: null,
  },
  {
    food: "Corn Bran",
    type: "Bread & Grains",
    serving: "cup",
    size: 1,
    weight: 76,
    protein: 6.4,
    fat: 0.7,
    carbohydrates: 65.1,
    calories: 170.2,
    sugar: 0.2,
  },
  {
    food: "Rice Bran",
    type: "Bread & Grains",
    serving: "cup",
    size: 1,
    weight: 118,
    protein: 15.8,
    fat: 24.6,
    carbohydrates: 58.6,
    calories: 372.9,
    sugar: 5.4,
  },
  {
    food: "Wheat Bran",
    type: "Bread & Grains",
    serving: "cup",
    size: 1,
    weight: 58,
    protein: 9,
    fat: 2.5,
    carbohydrates: 37.4,
    calories: 125.3,
    sugar: 2.7,
  },
  {
    food: "Nafish (Traditional Snack)",
    type: "Snacks",
    serving: "cup",
    size: 1,
    weight: 11,
    protein: 0.99,
    fat: 3.09,
    carbohydrates: 6.29,
    calories: 55,
    sugar: null,
  },
  {
    food: "Pear Nectar",
    type: "Beverages",
    serving: "cup",
    size: 1,
    weight: 248.59,
    protein: 0.67,
    fat: 0.05,
    carbohydrates: 34.6,
    calories: 134.24,
    sugar: null,
  },
  {
    food: "Apricot Nectar",
    type: "Beverages",
    serving: "3/4 cup",
    size: 0.75,
    weight: 250.99,
    protein: 0.93,
    fat: 0.23,
    carbohydrates: 36.12,
    calories: 140.55,
    sugar: null,
  },
  {
    food: "Nectarine",
    type: "Fruits",
    serving: "1 medium",
    size: 1,
    weight: 136,
    protein: 1.4,
    fat: 0.4,
    carbohydrates: 14.3,
    calories: 59.8,
    sugar: 10.7,
  },
  {
    food: "Cooked Noodles",
    type: "Bread & Grains",
    serving: "cup",
    size: 1,
    weight: 160,
    protein: 7.6,
    fat: 2.35,
    carbohydrates: 39.74,
    calories: 212.8,
    sugar: null,
  },
  {
    food: "Grouper Fish (Hamour)",
    type: "Meats",
    serving: "palm-sized",
    size: 1,
    weight: 100,
    protein: 19.3,
    fat: 3.4,
    carbohydrates: 0.2,
    calories: 109.3,
    sugar: null,
  },
  {
    food: "Hamour with Rice",
    type: "Meats",
    serving: "1/2 cup",
    size: 0.5,
    weight: 100,
    protein: 27.3,
    fat: 3.2,
    carbohydrates: 0,
    calories: 139.2,
    sugar: null,
  },
  {
    food: "Harees (Traditional)",
    type: "Traditional Dishes",
    serving: "1/4 cup",
    size: 0.25,
    weight: 100,
    protein: 9,
    fat: 0.7,
    carbohydrates: 8.3,
    calories: 76,
    sugar: null,
  },
  {
    food: "Asparagus",
    type: "Vegetables",
    serving: "cup",
    size: 1,
    weight: 134,
    protein: 2.9,
    fat: 0.2,
    carbohydrates: 5.2,
    calories: 26.8,
    sugar: 2.5,
  },
  {
    food: "Grape Leaves",
    type: "Vegetables",
    serving: "cup",
    size: 1,
    weight: 14,
    protein: 0.8,
    fat: 0.3,
    carbohydrates: 2.4,
    calories: 13,
    sugar: 0.9,
  },
  {
    food: "Yanam Fish",
    type: "Meats",
    serving: "palm-sized",
    size: 1,
    weight: 100,
    protein: 17.9,
    fat: 10.4,
    carbohydrates: 0,
    calories: 164.7,
    sugar: null,
  },
  {
    food: "Grilled Yanam Fish",
    type: "Meats",
    serving: "palm-sized",
    size: 1,
    weight: 100,
    protein: 25.9,
    fat: 5.6,
    carbohydrates: 0,
    calories: 154.8,
    sugar: null,
  },
];
export default foodData;